import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AdminLogin } from '@/components/admin/AdminLogin';
import { Layout } from '@/components/layout/Layout';
import Admin from '@/pages/Admin';

export function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      
      {/* Protected admin routes */}
      <Route element={<ProtectedRoute />}>
        <Route index element={<Admin />} />
      </Route>
    </Routes>
  );
}
